const rule = {
    username: [{
        required: true,
        message: '姓名不能为空',
        trigger: 'blur'
    },{
        pattern : "^[\u4e00-\u9fa5][\u4e00-\u9fa5]+[0-9]*$",
        message: '请填写正确的姓名',
        trigger: 'blur'
    }],
    position: [{
        required: true,
        type: 'string',
        message: '职位不能为空',
        trigger: 'blur'
    }],
    tkphone:[{
        required: true,
        pattern : "^(0|86|17951)?1[3456789][0-9]{9}$",
        message: '请填写正确的手机号',
        trigger: 'blur'
    }],
    email:[{
        required: true,
        type : 'email',
        message: '请填写正确的邮箱',
        trigger: 'blur'
    }],
    district_1st:[{
        required: true,
        message: '请选择省',
        trigger: 'change'
    }],
    district_2nd:[{
        required: true,
        message: '请选择市',
        trigger: 'change'
    }],
    district_3rd:[{
        required: true,
        message: '请选择区',
        trigger: 'change'
    }],
};

export default rule;


// WEBPACK FOOTER //
// ./src/validateRule/company/userBaseInfo.js